import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogClose } from "@angular/material/dialog";

import { ApiHelper } from "../../../helpers/apihelper";
import { FulfilmentRequest } from "../../../helpers/self-service/models/types";
import { AuthService } from "../../../services/authservice";

@Component({
  selector: "dialog-ip-prefixes-add",
  templateUrl: "dialog-ip-prefixes-add.html",
  styleUrls: ["../dialog-ip-prefixes-request/dialog-ip-prefixes-request.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, FormsModule, MatDialogClose, TranslatePipe],
})
export class DialogIPPrefixesAddComponent {
  private auth = inject(AuthService);
  private translate = inject(TranslateService);
  private api = inject(ApiHelper);

  protected readonly activeStep = signal(1);
  protected readonly errorMessage = signal("");
  protected readonly successMessage = signal("");

  protected __fulfilmentRequest: any;

  constructor() {
    this.__fulfilmentRequest = {};

    this.__fulfilmentRequest.fullName = this.auth.currentUser().displayName;
    this.__fulfilmentRequest.email = this.auth.currentUser().email;
    this.__fulfilmentRequest.phone = "";
    this.__fulfilmentRequest.ipRegister = "";
  }

  get disableSubmitButton() {
    return !this.__fulfilmentRequest.ipRegister;
  }

  next() {
    this.activeStep.update((activeStep) => activeStep + 1);
  }

  prev() {
    this.activeStep.update((activeStep) => activeStep - 1);
  }

  submit() {
    const customerId = this.auth.viewingCustomer().customerId;

    const request: FulfilmentRequest = {
      contacts: [
        {
          fullName: this.__fulfilmentRequest.fullName,
          email: this.__fulfilmentRequest.email,
          phone: this.__fulfilmentRequest.phone,
        },
      ],
      serviceRequest: "create",
      text: this.translate.instant("Dialog.IPP.IPRegister") + "\nAnswer:\n\n" + this.__fulfilmentRequest.ipRegister,
      product: "IP_PREFIX",
    };

    this.api
      .add_new_fulfilment_problem(customerId, JSON.stringify(request))
      .then(() => {
        this.successMessage.set(this.translate.instant("Selfservice.NotificationSent"));
        this.next();
      })
      .catch((err) => {
        if (err.error) {
          this.errorMessage.set(err.error.detail);
        }
      });
  }
}
